import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDocImagePresignedURLV2 = (
  matterId: string | undefined,
  docId: string | undefined,
  pageNumber: number,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery(
    [QueryEntity.PresignedGetDocumentImage, { docId, pageNumber }],
    async () => {
      try {
        const downloadResult = await fetch(
          `${APIBaseChronos}/api/matters/${matterId}/docs/${docId}/image/${pageNumber}`,
          fetchConfigGET,
        );

        if (!downloadResult.ok) throw new Error('Fetching document url failed');

        return await downloadResult.text();
      } catch {
        return null;
      }
    },
    {
      enabled: !!matterId && !!docId,
      refetchOnWindowFocus: false,
      staleTime: 590 * 1000,
      cacheTime: 590 * 1000,
    },
  );
};
